export enum ConclusionType {
  Agent = 'agent',
  Remote = 'remote',
}
